import { useState } from 'react';
import Reveal from '@/components/base/Reveal';

export default function SubscribeCta() {
  const [value, setValue] = useState('');
  const [tip, setTip] = useState('');

  const handleDemo = () => {
    if (!value.trim()) {
      setTip('先填一下你想接收更新的邮箱或昵称吧');
      return;
    }
    setTip('演示站点：订阅入口暂未开放，正式上线后会第一时间通知你');
  };

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <div className="grid grid-cols-1 gap-8 rounded-lg border border-background-200 bg-background-100/60 p-7 md:p-10 lg:grid-cols-[1.2fr_1fr] lg:items-center lg:gap-14">
            <div>
              <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
                <span className="h-px w-8 bg-primary-500" />
                更新订阅
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                重要节点更新时，第一时间告诉你
              </h2>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
                只推送已经过核对的时间线节点与合集归档，不做无意义的消息轰炸。你关心的事件有新进展，我们才会出现。
              </p>
            </div>

            <div>
              <div className="flex flex-col gap-3 sm:flex-row">
                <label className="flex h-11 flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3.5">
                  <i className="ri-mail-line text-base text-foreground-500" />
                  <input
                    type="email"
                    value={value}
                    onChange={(e) => {
                      setValue(e.target.value);
                      setTip('');
                    }}
                    placeholder="输入邮箱接收节点更新"
                    className="w-full bg-transparent text-sm text-foreground-800 placeholder:text-foreground-500 focus:outline-none"
                  />
                </label>
                <button
                  type="button"
                  onClick={handleDemo}
                  className="flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-notification-3-line text-base" />
                  订阅更新
                </button>
              </div>

              {tip && (
                <p className="mt-3 flex items-start gap-1.5 text-xs leading-relaxed text-foreground-600">
                  <i className="ri-information-line mt-px text-sm text-primary-500" />
                  {tip}
                </p>
              )}

              <p className="mt-3 text-xs text-foreground-500">演示站点，当前不会真的发送邮件。</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}